<template>
        <modal
            v-if="currEvent"
            name="event"
            class="c-event-modal"
            height="auto"
            :adaptive="true"
            :width="450"
        >
            <header class="c-event-modal__header">
                <img class="c-event-modal__image" :src="currEvent.backgroundImage" :alt="currEvent.name">
                <div class="c-event-modal__header-content">
                    <h2 class="c-event-modal__location">{{ currEvent.eventName }}</h2>
                    <h3 class="c-event-modal__date">{{ currEvent.timeRange }}</h3>
                </div>
            </header>
            <div class="c-event-modal__content">
                <h2 class="c-event-modal__title">{{ currEvent.popupTitle }}</h2>
                <p class="c-event-modal__copy">{{ currEvent.popupCopy }}</p>
            </div>
            <div class="c-event-modal__cta">
                <router-link class="btn btn--primary c-event-modal__btn" @click.native="resetState()" to="/register/event">Sign up</router-link>
                <a href="" ></a>
            </div>
        </modal>
</template>

<script>
export default {
    name: 'EventModal',
    props: {
        currEvent: {
            type: {
                id: Number,
                eventName: String,
                timeRange: String,
                popupTitle: String,
                popupCopy: String,
                backgroundImage: String,
            },
        },
    },
    methods: {
        show () {
            this.$modal.show('event');
        },
        hide () {
            this.$modal.hide('event');
        }
    },
    mounted() {
      this.show();
    }
}
</script>

<style scoped>

</style>
